<template>
    <div class="">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fechaCierre }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start" v-if="chkCierre == 1">
                <input type="month" v-model="fechaCierre" class="form-control" readonly>
            </div>
            <div v-else>
                <input type="month" v-model="fechaCierre" class="form-control">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="procesarCierre">{{ labels.procesar }}</b-button>
        </div>
        <ConsultaCierreMensual :listCierreMensual="listCierreMensual"></ConsultaCierreMensual>
    </div>
</template>

<script>
import ContratoCierre from '../../services/ContratoCierre';
import ConsultaCierreMensual from '../consultaCierres/ConsultaCierreMensual.vue';
import FechaRegistro from '../../services/FechaRegistro';
export default {
    name : 'CierreMensual',
    components : { ConsultaCierreMensual },
    data: () => ({
        fechaCierre : '',
        listCierreMensual : [],
        chkCierre : 0
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Cierre Mensual',
                    fechaCierre : 'Fecha cierre:',
                    procesar : 'Procesar'
                }
            }else{
                return {
                    title : 'Monthly Closing',
                    fechaCierre : 'Closing date:',
                    procesar : 'Process'
                }
            }
        }
    },
    methods:{
        procesarCierre() {
/*
            const fecha = new Date();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();
            const fechaActual = `${anio}-${mes}`; // formato correcto YYYY-MM

            if (!this.fechaCierre) {
                this.$toast.error('Diligenciar la fecha.');
                return;
            }

            // Comparación correcta entre fechas YYYY-MM
            if (this.fechaCierre >= fechaActual) {
                this.$toast.error('La fecha cierre no puede ser igual o mayor al mes actual.');
                return;
            }
*/
            const datos = {
                fechaCierre: this.fechaCierre,
                idUser: this.$store.state.userId
            };

            ContratoCierre.createCierreContrato(datos)
            .then((res) => {
                this.$toast.success(res.data.message);
                this.consultaCierres();
            })
            .catch((err) => {
                if (err.response?.status === 500) {
                    this.$toast.error(err.response.data.error);
                } else {
                    this.$toast.error("Algo pasó, inténtalo de nuevo");
                }
            });
        },
        consultaCierres(){
            ContratoCierre.getContratoCierreByFecha(this.fechaCierre)
            .then((res) => {
                // console.log(res.data);
                this.listCierreMensual = res.data.listContratosCerrados
            })
            .catch((err) => console.log(err))
        }
    },
    mounted(){

        FechaRegistro.getAllFechaRegistro()
        .then((res) => {
            // console.log(res.data);
            this.fechaCierre = res.data.periodo_cierre
            this.chkCierre = res.data.flag_cierre
        })
        .catch((err) => {
            console.log(err);
            if(err.response.status == 500){
                this.$toast.error(err.response.data.msg)
            }else{
                this.$toast.error("Algo pasó, intentalo de nuevo")
            }
        })
    }
}
</script>

<style>

</style>
